import {Brick, registerBrick} from 'olympe';
import {createPRJson} from '../createPRJson';

/**
 * Convert a Purchase Request (JavaScript object) to its JSON representation
 */
export default class PRToJSON extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {PurchaseRequest} pR
     * @param {function(string)} setJSON
     */
    update($, [pR], [setJSON]) {
        setJSON(createPRJson(pR));
    }
}

registerBrick('01917e8f0df838761d2f', PRToJSON);
